import { Block, Section } from '../types';

export function findBlock(sections: Section[], blockId: Block['id']): Block | undefined {
  for (let section of sections) {
    for (let block of section.blocks) {
      if (block.id === blockId) {
        return block;
      }
    }
  }
}
